import { Badge, Icon } from '@chakra-ui/react';
import React from 'react';

import { useQAContext } from './QAContext';
import { FiPlayCircle } from 'react-icons/fi';

export const QAModeControls = () => {
  const { generateAllTapes, state } = useQAContext();
  const playIconSize = '30px';

  return (
    <>
      <Icon
        as={FiPlayCircle}
        color="green.300"
        boxSize={playIconSize}
        onClick={async () => {
          await generateAllTapes();
        }}
      />
      <Badge ml="2" variant="solid" colorScheme="blackAlpha">
        {state.qaStatus}
      </Badge>
    </>
  );
};
